<template>
    <ion-list>
        <ion-list-header>
            <ion-label>{{ participant.display_name }}</ion-label>
        </ion-list-header>
        <ion-item v-if="participant.contact_id" button @click="openContact">
            <ion-icon slot="end" md="person-circle" ios="person-circle"></ion-icon>
            <ion-label>{{ $t('ncrypt.message_participant_popup.open_contact_person') }}</ion-label>
        </ion-item>
        <ion-item v-if="participant.receive_status" lines="none">
            <receive-status-progress-marks :statusDetails="participant.receive_status" slot="end"/>
        </ion-item>
    </ion-list>
</template>

<script>
    import ReceiveStatusProgressMarks from "../ui-elements/ReceiveStatusProgressMarks";
    export default {
        name: "ParticipantDetailsPopover",
        components: {ReceiveStatusProgressMarks},
        props: {
            participant: {type: Object},
        },
        methods: {
            async close() {
                await this.$ionic.popoverController.dismiss();
            },
            async openContact() {
                if (!this.participant.contact_id) {
                    return;
                }

                await this.close();

                await this.$router.push({
                    name: 'contact',
                    params: {
                        id: this.participant.contact_id,
                    },
                });
            },
        },
    }
</script>
